/* eslint-disable max-len */
// 搶券有 so 微信訂閱
import { i18n } from '@/i18n';
import { promQrySubcWxMsg, promSubcWxMsgV2, PromSubcWxMsgV2State } from '@tencent/wphk-act-base-cgi';
import { to } from '@tencent/wphk-base-utils';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';
import { isSupportWxSubscribe, getAcceptTemplates } from '@tencent/wphk-components-wx-subscribe/wx-subscribe-util';

// 渠道 id 抢券有 so
const CHANLE_WECOUPON = 'coupon_task';

// 公众号配置的模板 id
type ISubscribeConfig = {
  id: string; // 用于给后台请求
  templateId: string; // 用于给微信订阅open tag, 模板id在公众号平台配置
}[];
const SUBSCRIBE_CONFIG: ISubscribeConfig = [
  {
    id: 'subc.sp_coupon_expire_notify',
    templateId: 'vHa9Vo07X7UxZbphO2dFLFmKsH9UPHJHDcH223doFzA', // 優惠券到期
  },
  {
    id: 'subc.sp_coupon_online_notify',
    templateId: 'et6gJ0G0Ce5XzObS4zmkAEC8fwMIvTMfhB5R6ZfkQX0', // 優惠券上新
  },
];
export const SUBSCRIBE_TYPE = {
  vHa9Vo07X7UxZbphO2dFLFmKsH9UPHJHDcH223doFzA: {
    text: i18n('優惠券到期失效前'),
    desc: '优惠券到期',
  },
  et6gJ0G0Ce5XzObS4zmkAEC8fwMIvTMfhB5R6ZfkQX0: {
    text: i18n('上線新優惠時'),
    desc: '优惠券上新',
  },
};

/** localstorage 记录的上次弹出订阅消息弹窗的时间 */
const LAST_SUBSCRIBE_TIME = 'LAST_SUBSCRIBE_TIME';

/**
 * 把当前时间设置到本地存储中（弹出订阅消息弹窗的时间）
 */
export function setLastSubTime() {
  localStorage.setItem(LAST_SUBSCRIBE_TIME, String(getServerTime().getTime()));
}

/**
 * 获取本地存储的时间
 */
function getLastSubTime() {
  return localStorage.getItem(LAST_SUBSCRIBE_TIME);
}

/**
 * 判断上次弹出订阅弹窗的时间是否在当周
 */
function isLastSunTimeInWeek() {
  const lastSubTime = getLastSubTime();
  if (!lastSubTime) return false;

  const curTime = getServerTime();
  const startTimeOfWeek = dayjs(curTime).startOf('week');
  const endTimeOfWeek = dayjs(curTime).endOf('week');

  return startTimeOfWeek.isBefore(dayjs(Number(lastSubTime))) && dayjs(Number(lastSubTime)).isBefore(endTimeOfWeek);
}

/**
 * 获取订阅弹窗提示内容
 */
function getTipContent(unSubscribeTmpIds: string[]) {
  if (unSubscribeTmpIds.length === 2) {
    // 两条未订阅
    return i18n('推薦訂閱優惠提醒，將在優惠券到期失效前和上線新優惠時通知你，避免錯過優惠');
  }
  if (unSubscribeTmpIds.length === 1) {
    // 一条未订阅
    const tmpId = unSubscribeTmpIds[0];
    return i18n('推薦訂閱優惠提醒，將在{{type}}通知你，避免錯過優惠', { type: SUBSCRIBE_TYPE[tmpId].text });
  }
  // 零条未订阅
  return '';
}

/**
 * 是否展示微信訂閱彈窗
 */
export async function isShowWeCouponWxSubscribe(): Promise<{
  isShow: boolean;
  unSubscribeTmpIds?: string[];
  subscribeTipContent?: string;
}> {
  // 是否支持微信订阅
  const isWxSupport = isSupportWxSubscribe();
  /**
   * 支持微信订阅
   * 本周没有提示过
   * 未订阅数为 2 或 1 条
   */
  if (!isWxSupport || isLastSunTimeInWeek()) {
    return { isShow: false };
  }
  // 获取未订阅的模板
  const unSubscribeTmpIds = await getUnSubscribeTmpIds();
  return {
    isShow: unSubscribeTmpIds.length >= 1, // 未订阅数为 2 或 1 条（即已订阅数量为 0 条或 1 条）
    unSubscribeTmpIds,
    subscribeTipContent: getTipContent(unSubscribeTmpIds),
  };
}

/** 获取未订阅的模板Id列表 */
async function getUnSubscribeTmpIds() {
  const [err, res] = await to(promQrySubcWxMsg({ chnId: CHANLE_WECOUPON }));
  console.log('======qryWxSubscribe', err, res);
  if (err || !res) {
    return [];
  }
  const resSubcTmpList = res.list
    .filter(item => item.subcState === PromSubcWxMsgV2State.HAS_SUBSCRIBE)
    .map(item => item.tplId);
  console.log('=====qryWxSubscribe has subc', resSubcTmpList);
  const unSubscribeTmpIds = SUBSCRIBE_CONFIG.filter(config => !resSubcTmpList.includes(config.id)).map(item => item.templateId);
  console.log('=====qryWxSubscribe unSubscribeTmpIds', unSubscribeTmpIds);
  return unSubscribeTmpIds;
}

/** 处理onSuccess回调 */
export function handleSubscribeRes(res) {
  // 把用户接收的模板id发给后端
  const acceptTemplates = getAcceptTemplates(res);
  if (acceptTemplates.length > 0) {
    recordWxSubscribe(acceptTemplates);
  }
  // 如果為true，則調用方toast訂閱成功
  return acceptTemplates.length > 0;
}

// 调用订阅
const recordWxSubscribe = async (tmpIds: string[]) => {
  const tplIds = getTmpKeyByIds(tmpIds);
  console.log('======tplIds', tplIds);
  // 静默调用即可
  await to(promSubcWxMsgV2({ chnId: CHANLE_WECOUPON, tplIds }));
};

/** 根据templateId获得对应的id给后端 */
const getTmpKeyByIds = (tmpIds: string[]) => (SUBSCRIBE_CONFIG || []).filter(item => tmpIds.includes(item.templateId)).map(config => config.id);
